import { useState, useEffect } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { journalTemplatePresets } from '@/lib/journalTemplates';

interface TitleControlsProps {
  plotlyJson?: any;
  onUpdate: (updateType: string, value: any) => void;
}

export function TitleControls({ plotlyJson, onUpdate }: TitleControlsProps) {
  const [titleText, setTitleText] = useState(plotlyJson?.layout?.title?.text || '');
  const [subtitleText, setSubtitleText] = useState(plotlyJson?.layout?.title?.subtitle || '');
  const [activeTemplate, setActiveTemplate] = useState<string | null>(null);

  useEffect(() => {
    const currentTitle = plotlyJson?.layout?.title?.text || '';
    const currentSubtitle = typeof plotlyJson?.layout?.title?.subtitle === 'string'
      ? plotlyJson.layout.title.subtitle
      : (plotlyJson?.layout?.title?.subtitle?.text || '');
    setTitleText(currentTitle);
    setSubtitleText(currentSubtitle);
  }, [plotlyJson?.layout?.title?.text, plotlyJson?.layout?.title?.subtitle]);

  return (
    <div className="space-y-3">
      <div>
        <Label className="text-sm text-muted-foreground">Title</Label>
        <Input
          className="mt-1"
          value={titleText}
          onChange={(e) => {
            setTitleText(e.target.value);
            const templateFontSizes = (plotlyJson?.layout as any)?._templateFontSizes;
            const currentTitle = plotlyJson?.layout?.title || {};
            const currentSubtitle = typeof currentTitle.subtitle === 'string'
              ? currentTitle.subtitle
              : (currentTitle.subtitle?.text || '');
            
            const titleUpdate: any = {
              text: e.target.value,
              font: {
                ...(currentTitle.font || {}),
                ...(templateFontSizes?.title ? { size: templateFontSizes.title } : {}),
                ...(currentTitle.font?.family ? { family: currentTitle.font.family } : {}),
                ...(currentTitle.font?.color ? { color: currentTitle.font.color } : {})
              }
            };
            
            if (currentSubtitle) {
              if (typeof currentTitle.subtitle === 'object' && currentTitle.subtitle !== null) {
                titleUpdate.subtitle = currentTitle.subtitle;
              } else {
                titleUpdate.subtitle = currentSubtitle;
              }
            }
            
            onUpdate('layout.title', titleUpdate);
          }}
          placeholder="Enter plot title"
        />
      </div>
      <div>
        <Label className="text-sm text-muted-foreground">Subtitle</Label>
        <Input
          className="mt-1"
          value={subtitleText}
          onChange={(e) => {
            setSubtitleText(e.target.value);
            const templateFontSizes = (plotlyJson?.layout as any)?._templateFontSizes;
            const currentTitle = plotlyJson?.layout?.title || {};
            const currentTitleText = currentTitle.text || '';
            
            const titleUpdate: any = {
              text: currentTitleText,
              font: {
                ...(currentTitle.font || {}),
                ...(templateFontSizes?.title ? { size: templateFontSizes.title } : {}),
                ...(currentTitle.font?.family ? { family: currentTitle.font.family } : {}),
                ...(currentTitle.font?.color ? { color: currentTitle.font.color } : {})
              }
            };
            
            if (e.target.value) {
              if (templateFontSizes?.subtitle) {
                titleUpdate.subtitle = {
                  text: e.target.value,
                  font: {
                    size: templateFontSizes.subtitle,
                    family: currentTitle.font?.family || plotlyJson?.layout?.font?.family,
                    color: currentTitle.font?.color || plotlyJson?.layout?.font?.color || '#000'
                  }
                };
              } else {
                titleUpdate.subtitle = e.target.value;
              }
            }
            
            onUpdate('layout.title', titleUpdate);
          }}
          placeholder="Enter subtitle (optional)"
        />
      </div>
    </div>
  );
}










